import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

function installId() {
  let v = localStorage.getItem("cc_install");
  if (!v) {
    v = (window.crypto?.randomUUID?.() || String(Math.random()).slice(2) + Date.now());
    localStorage.setItem("cc_install", v);
  }
  return v;
}

function fingerprint() {
  const s = window.screen || {};
  return [navigator.userAgent, `${s.width}x${s.height}x${s.colorDepth}`, Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.language, navigator.hardwareConcurrency || 0].join("|");
}

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  c.headers["X-Device-Id"] = installId();
  c.headers["X-Device-Fp"] = fingerprint();
  return c;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const canRefresh = !url.startsWith("/auth/") || url === "/auth/me";
    if (err.response?.status === 401 && !cfg._retry && canRefresh) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message ? "No se ha podido completar la acción. Revisa tu conexión." : "Algo ha fallado.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
